import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

export default function ErrorMessageDialog(props) {
    if (props.errMsg === 'ROOM ALREADY REGISTERED') {
        return (
            <DialogContent>
                <DialogContentText sx={{ paddingTop: 2, textAlign: "center", fontSize: 17, color: "black" }}>
                    Room Number Already Registered
                </DialogContentText>
                <DialogContentText sx={{ paddingLeft: 1, paddingTop: 1, fontSize: 14 }}>
                    If this is a mistake,
                </DialogContentText>
                <DialogContentText sx={{ paddingLeft: 1, fontSize: 14 }}>
                    please contact Housing Services
                </DialogContentText>
                <DialogContentText sx={{ paddingLeft: 1, paddingTop: 1, fontSize: 14 }}>
                    or email zerowaste@nus.edu.sg
                </DialogContentText>
                <DialogContentText sx={{ paddingLeft: 1, paddingTop: 1, fontSize: 14 }}>
                    with your RC/Hall, room number and height to reset your password.
                </DialogContentText>
            </DialogContent>
        )
    } else if (props.errMsg === 'INVALID ROOM') {
        return (
            <DialogContent>
                <DialogContentText sx={{ paddingTop: 2, textAlign: "center", fontSize: 17, color: "black" }}>
                    Invalid Room Number
                </DialogContentText>
                <DialogContentText sx={{ paddingLeft: 1, paddingTop: 1, textAlign: "center", fontSize: 12 }}>
                    Please check that the correct RC/Hall or room number has been keyed in
                </DialogContentText>
            </DialogContent>
        )
    } else if (props.errMsg === 'reCaptcha Error') {
        return (
            <DialogContent>
                <DialogContentText sx={{ paddingTop: 2, textAlign: "center", fontSize: 17, color: "black" }}>
                    Error Verification
                </DialogContentText>
                <DialogContentText sx={{ paddingLeft: 1, paddingTop: 1, textAlign: "center", fontSize: 14 }}>
                    Please refresh and try again
                </DialogContentText>
            </DialogContent>
        )
    } else if (props.errMsg === 'INFO_REQUIRED') {
        return (
            <DialogContent>
                <DialogContentText sx={{ paddingTop: 2, textAlign: "center", fontSize: 17, color: "black" }}>
                    Information Required
                </DialogContentText>
                <DialogContentText sx={{ paddingLeft: 1, paddingTop: 1, textAlign: "center", fontSize: 14 }}>
                    Please fill complete information
                </DialogContentText>
            </DialogContent>
        )
    } else if (props.errMsg === 'HEIGHT_RANGE') {
        return (
            <DialogContent>
                <DialogContentText sx={{ paddingTop: 2, textAlign: "center", fontSize: 17, color: "black" }}>
                    Out of Height Range
                </DialogContentText>
                <DialogContentText sx={{ paddingLeft: 1, paddingTop: 1, textAlign: "center", fontSize: 14 }}>
                    Height is available between 120 and 200
                </DialogContentText>
            </DialogContent>
        )
    }
}
